export function isMissing<T>(value: T | null): value is null {
  return value === undefined || value === null;
}

export function isPresent<T>(value: T | null): value is NonNullable<T> {
  return !isMissing(value);
}
